import './LandingPage.css';

import InventoryScaling from '../Components/LandingPageComponents/Main/InvantoryScaling/InventoryScaling';
// import AutomateContent from '../Components/LandingPageComponents/Main/Automate/AutomateContent';
import Innovation from '../Components/LandingPageComponents/Main/Innovation/Innovation';
import ChooseEase from '../Components/LandingPageComponents/Main/ChooseEase/ChooseEase';
import StandOut from '../Components/LandingPageComponents/Main/StandOut/StandOut';
import SideNav from '../Components/LandingPageComponents/Sidebar';
import Header from './LandingPageComponents/HeaderLanding';
import HeroSection from '../Components/LandingPageComponents/HeroSection';
import KeyClients from '../Components/LandingPageComponents/Main/KeyClients';
import Footer from './Footer';
import Pricing from './LandingPageComponents/Pricing';
import StartupRecognition from './StartupRecognition';

import { useEffect, useState } from 'react';
import { Button, Modal } from 'antd';
import { useNavigate } from 'react-router-dom';
import FreeTrialForm from './LandingPageComponents/Main/FreeTrialForm';

function LandingPage() {
    const [isModalOpen, setIsModalOpen] = useState(false);
    const navigate = useNavigate();

    useEffect(() => {
        const timer = setTimeout(() => {
            setIsModalOpen(true);
        }, 5000); // 5 seconds

        return () => clearTimeout(timer); // cleanup on unmount
    }, []);

    const handleOk = () => {
        // navigate("/requestdemo");
        setIsModalOpen(false);
    };

    const handleCancel = () => {
        setIsModalOpen(false);
    };

    return (
        <div className='main -mb-6 p-0'>
            <Modal
                title={null}
                open={isModalOpen}
                onCancel={handleCancel}
                footer={null}
                centered
                // closable={false}
                styles={{
                    body: {
                        padding: 0,
                    },
                    content: {
                        padding: 0,
                        margin: 0,
                        borderRadius: 20,
                    },
                }}
            >
                {/* <div style={{ height: "100%", display: "flex", alignItems: "center", justifyContent: "center" }}> */}
                    <FreeTrialForm />
                {/* </div> */}
            </Modal>


            <div className="main-header ">
                <Header />
            </div>

            <div className="main-sidenav">
                <SideNav />
            </div>

            <div>
                <div className="App">
                    <HeroSection />
                </div>
                <InventoryScaling />
                <ChooseEase />
                <KeyClients />
                <StandOut />
                <Innovation />
                <div id="pricing-section">
                    <Pricing />
                </div>
            </div>
            <StartupRecognition />
            <Footer />
        </div>
    );
}

export default LandingPage;
